import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserModel } from "../../_core/_model.ts";
import { GetUsers } from "../../_core/_request.ts";
import UserRoleDrawer from "./UserRoleDrawer.tsx";
import UserTable from "./UserTable.tsx";
import LoadingOverlay from "../../UIComponents/LoadingOverlay.tsx";
import { useAppContext } from "../../context/AppContext.tsx";
import { AuthContext } from "../../context/AuthContext.js";

export function UserWrapper() {
    const [searchParams] = useSearchParams();
    const [selectedRow, setSelectedRow] = useState<any>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { user: loginUser } = useContext(AuthContext);
    useEffect(() => {
        let tId = searchParams.get("id");
        if (tId != null) {
            setLoading(true);
            let uId = parseInt(tId);
            if (uId > 0) {
                GetUsers({ userID: uId, userName: "", email: "", roleID: null, roleGroupID: null, managerUserID: null, appliationAccess: null }).then((x) => {
                    setSelectedRow(x.data[0]);
                    setLoading(false);
                })
            }
            else {
                setSelectedRow({
                    userID: 0,
                    userName: "",
                    userFirstName: "",
                    userLastName: "",
                    email: "",
                    password: "",
                    passwordHash: "",
                    role: "",
                    product: "",
                    status: "Active",
                    createdBy: loginUser.userID,
                    createdAt: "",
                    isAdUser: 0,
                    applicationAccess: 0
                })
                setLoading(false);
            }
        }
        else
            setSelectedRow(undefined)
    }, [searchParams])

    return (
        loading ? <LoadingOverlay msg="Loading Users" /> :
            typeof selectedRow != 'undefined' ?
                <UserRoleDrawer user={selectedRow} onClose={(refresh) => {
                    navigate("/users");
                }} /> :
                <UserTable />
    )
}

export default UserWrapper;